import { render, staticRenderFns } from "./LoanNav.vue?vue&type=template&id=5706e290&scoped=true&"
import script from "./LoanNav.vue?vue&type=script&lang=ts&"
export * from "./LoanNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706e290",
  null
  
)

export default component.exports